import React from 'react';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

function Contact() {
    return (
        <div className="page-container">
            <p style={{ fontSize: '1.2rem', marginBottom: '1rem' }}>For inquiries, please reach us at:</p>
            <div className="contact-info">
                <div className="contact-item">
                    <EmailIcon style={{ color: '#4b6043', fontSize: '1.5rem' }} />
                    <span style={{ fontSize: '1rem', color: '#4b6043' }}>FitEstateestateproject@qidyyy.com</span>
                </div>
                <div className="contact-item">
                    <PhoneIcon style={{ color: '#4b6043', fontSize: '1.5rem' }} />
                    <span style={{ fontSize: '1rem', color: '#4b6043' }}>(+84)  818-383-171</span>
                </div>
            </div>
        </div>
    );
}

export default Contact;
